<template>
  <div class="pt-4 px-2">
    <div class="mb-4">
      <div class="az-text dados-edital-numero-edital" v-if="licitacao && licitacao.numeroEdital">
        <label class="font-weight-bold">Número do Edital</label>
        <p class="mb-0">{{ licitacao.numeroEdital }}</p>
      </div>
    </div>
    <div xs12 sm12 d-flex v-if="anexos.length > 0">
      <span class="font-weight-bold az-subtitle primary--text">Anexos do Edital</span>
      <hr class="divisor" />
    <v-data-table :headers="colunas" :items="anexos"
                  :total-items="anexos.length"
                  :loading="false" hide-actions
                  no-data-text="Não há anexos disponíveis"
                  class="az-table-list">
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <div class="nobr">
              <span v-if="props.item.relatorioNome">{{ props.item.relatorioNome }}</span>
              <span v-else>{{ getTipoAnexo(props.item.tipo) }}</span>
            </div>
          </td>
          <td>
            <div class="nobr">{{ getTipoAnexo(props.item.tipo) }}</div>
          </td>
          <td>
            {{ props.item.dataCadastro | az-date('DD/MM/YYYY HH:mm') }}
          </td>
          <td>
            <div class="nobr">{{ props.item.arquivoNome }}</div>
          </td>
          <td>
            {{ getDescricaoSituacao(props.item.situacao) }}
          </td>
          <td style="text-align: center;">
            <v-tooltip top>
              <a slot="activator" v-if="props.item.id" title="Download do Anexo"
                 target="_blank" class="az-action-link-icon"
                 @click="abrirModalFornecedorIdentificacao(props.item)">
                <v-icon>get_app</v-icon>
              </a>
              Baixar Anexos
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    </div>
    <modal-confirmar-captcha-download :exibir="exibirModalConfirmarCaptchaDownload"
                                           :item="documentoDownload"
                                           :licitacaoId="licitacaoId"
                                           max-width="335"
                                           @fecharModal="exibirModalConfirmarCaptchaDownload=false"/>

    <modal-fornecedor-identificacao :exibir="exibirModalFornecedorIdentificacao"
                                    @continuarAcao="baixarArquivo"
                                    @fecharModal="exibirModalFornecedorIdentificacao=false"/>
  </div>
</template>
<script>
import {actionTypes, tiposAnexo} from '@/core/constants'
import modalConfirmarCaptchaDownload from '@/views/components/ModalConfirmarCaptchaDownload'
import ModalFornecedorIdentificacao from '@/views/components/ModalFornecedorIdentificacao.vue'
import { mapState } from 'vuex'

export default {
    name: 'CredenciamentoVisualizacaoDadosEdital',
    components: {ModalFornecedorIdentificacao, modalConfirmarCaptchaDownload },
    data(){
        return{
            tiposAnexo,
            licitacaoId: null,
            colunas: [
                {
                    value: 'relatorio',
                    text: 'Relatório',
                    align: 'left',
                    width: '25%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'tipo',
                    text: 'Tipo',
                    align: 'left',
                    width: '20%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'data',
                    text: 'Data',
                    align: 'left',
                    width: '15%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'nome',
                    text: 'Nome',
                    align: 'left',
                    width: '30%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'situacao',
                    text: 'Situação',
                    align: 'left',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    text: 'Ações',
                    align: 'center',
                    width: '10%',
                    sortable: false,
                    class: 'primary--text'
                },
            ],
            anexos: [],
            exibirModalConfirmarCaptchaDownload: false,
            exibirModalFornecedorIdentificacao: false,
            documentoDownload: {}
        }
    },
    computed:{
        ...mapState(['licitacao']),
        RecaptchaDownloadPubAtivo(){
            return this.$store.state.parametros.recaptchaDownloadPubAtivo
        }
    },
    async created() {
        await this.setLicitacaoId()
    },
    async mounted() {
        await this.buscarAnexos()
    },
    methods:{
        async buscarAnexos(){
            const resultado = await this.$store.dispatch(actionTypes.BUSCAR_ANEXOS_EDITAL_CREDENCIAMENTO, this.licitacaoId)
            this.anexos = resultado.anexos
        },
        getTipoAnexo(tipo){
            const tipoSelecionado = tiposAnexo.find(tipoAnexo => tipoAnexo.chave === tipo)
            return tipoSelecionado ? tipoSelecionado.label : ''
        },
        getDescricaoSituacao(situacao){
            if(!situacao) return '-'
            const s = String(situacao).toUpperCase()
            if(s === 'ATIVO') return 'Ativo'
            if(s === 'INATIVO') return 'Inativo'
            return situacao
        },
        setLicitacaoId(){
            this.licitacaoId = Number(this.$route.params.id)
        },
        async baixarArquivo(fornecedor) {
            const doc = {fornecedor: fornecedor, ...this.documentoDownload}
            if (this.RecaptchaDownloadPubAtivo) {
                this.exibirModalFornecedorIdentificacao=false
                this.abrirModalConfirmarCaptchaDownload(doc)
            } else {
                const payload = {
                    licitacaoId: this.licitacaoId,
                    documentoVirtualizadoId: doc.idVirtualizado,
                    nomeArquivo: doc.arquivoNome,
                    externo: doc.externo,
                    uri: doc.arquivoUri,
                    tipoAnexo: doc.tipo,
                    areaPublica: true,
                    fornecedorNomeRazaoSocial: doc.fornecedor.nomeRazaoSocial,
                    fornecedorCpfCnpj: doc.fornecedor.cpfCnpj,
                    fornecedorEmail: doc.fornecedor.email,
                    fornecedorTelefone: doc.fornecedor.telefone,

                }
                await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_ARQUIVO, {payload})
                this.exibirModalFornecedorIdentificacao = false
            }
        },
        abrirModalConfirmarCaptchaDownload(documento) {
            this.documentoDownload = documento
            this.exibirModalConfirmarCaptchaDownload = true
        },
        abrirModalFornecedorIdentificacao(documento) {
            this.documentoDownload = documento
            this.exibirModalFornecedorIdentificacao = true
        },
    }
}
</script>
<style lang="stylus">
.nobr
  white-space nowrap
  hyphens none

.divisor
  margin-bottom 20px

</style>